export function isAdministratorPosition(position) {
    return /управляющий|администратор|шеф-повар|начальник цеха/i.test(position);
}
